import { useNavigate, useParams } from 'react-router-dom';
import { AppLayout } from '../components/templates/AppLayout/AppLayout';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/Sidebar';
import { PageContent } from '../components/templates/PageContent/PageContent';
import { PageHeader } from '../components/templates/PageHeader/PageHeader';
import { GalleryContainer } from '../components/gallery/GalleryContainer';
import { Button } from '../components/atoms/Button/Button';
import { useTranslation } from '../i18n/useTranslation';

export function GalleryPage() {
  const { aquariumId = '' } = useParams<{ aquariumId: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AppLayout
      header={<Header />}
      sidebar={<Sidebar />}
      main={
        <PageContent width="wide">
          <PageHeader
            title={t('gallery.title')}
            description={t('gallery.emptyDescription')}
            actions={
              aquariumId ? (
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => navigate(`/aquariums/${aquariumId}/comparisons`)}
                >
                  {t('gallery.openComparisons')}
                </Button>
              ) : undefined
            }
          />
          <GalleryContainer
            aquariumId={aquariumId}
            aquariumName={t('gallery.title')}
          />
        </PageContent>
      }
    />
  );
}

export default GalleryPage;
